import { OptionDto } from "@/dtos";
import cellphoneCodes from '@/helpers/jsons/cellphone-country.json';

export const getCellphoneCountryOptions = () => {
    return cellphoneCodes.map(x => {
        const option: OptionDto = {
            label: x.name + " " + x.emoji + ` (${x.dial_code})`,
            value: x.dial_code as any
        }
        return option;
    });
}

export const getCellphoneCountryOption = (code: string) => {
    const cellphoneCode = cellphoneCodes.find(x => x.dial_code == code);
    if (cellphoneCode) {
        const option: OptionDto = {
            label: cellphoneCode.name + " " + cellphoneCode.emoji + ` (${cellphoneCode.dial_code})`,
            value: cellphoneCode.dial_code as any
        }

        return option;
    }

    return {
        label: '',
        value: '' as any
    } as OptionDto;
}